import { PropertyTaskDTO } from "../DTO/propertyTaskDTO";

export type Task = InsuranceTask | AuditorInformationTask | OrderAppointingReceiverTask | BondFiledTask | OathFiledTask | ReceiverReportsTask | OrderTerminatingReceiverTask | BankruptcyStayTask | BankAccountTask | ValuationTask;

export class InsuranceTask {
    public insurance: boolean = false;
    public paidBy?: string;
    public expiration?: string;
    public carrier?: string;
    public policy?: string;
    public agent?: string;
    public phone?: string;
    public email?: string;
    public annualCost?: number;

    public serialize(): any {
        return { ...this};
    }
    public static deserialize(raw: any): InsuranceTask {
        return Object.assign(new InsuranceTask(), raw);
    }

    get daysUntilExpiration(): number {
        if (!this.expiration || !this.insurance) return 0;
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const exp = new Date(this.expiration); // only convert here when needed
        exp.setHours(0, 0, 0, 0);
        const diff = exp.getTime() - today.getTime();
        return Math.ceil(diff / (1000 * 60 * 60 * 24));
    }
}

export class AuditorInformationTask {
    public infoChanged: boolean = false;
    public dateChanged?: string;
    public userId?: string;

    public serialize(): any {
        return { ...this };
    }
    public static deserialize(raw: any): AuditorInformationTask {
        return Object.assign(new AuditorInformationTask(), raw);
    }
}

export class OrderAppointingReceiverTask {
    public dateAppointed?: string;
    public reporting?: string;

    public serialize(): any {
        return { ...this };
    }
    public static deserialize(raw: any): OrderAppointingReceiverTask {
       return Object.assign(new OrderAppointingReceiverTask(), raw);
    }
}

export class BondFiledTask {
    public filed: boolean = false;
    public dateFiled?: string;
    public userId?: string;
    public amount?: number;

    public serialize(): any {
        return { ...this};
    }
    public static deserialize(raw: any): BondFiledTask {
        return Object.assign(new BondFiledTask(), raw);
    }
}

export class OathFiledTask {
    public filed: boolean = false;
    public dateFiled?: string;
    public userId?: string;

    public serialize(): any {
        return { ...this };
    }
    public static deserialize(raw: any): OathFiledTask {
        return Object.assign(new OathFiledTask(), raw);
    }
}

export class ReceiverReportsTask {
    public firstReport?: string;
    public frequency?: string;

    public serialize(): any {
        return { ...this };
    }
    public static deserialize(raw: any): ReceiverReportsTask {
        return Object.assign(new ReceiverReportsTask(), raw);
    }
}

export class OrderTerminatingReceiverTask {
    public dateTerminated?: string;
    public userId?: string;

    public serialize(): any {
        return { ...this};
    }
    public static deserialize(raw: any): OrderTerminatingReceiverTask {
        return Object.assign(new OrderTerminatingReceiverTask(), raw);
    }
}

export class BankruptcyStayTask {
    public stay: boolean = false;
    public dateOfStay?: string;
    public reliefFromStay?: string;

    public serialize(): any {
        return { ...this};
    }
    public static deserialize(raw: any): BankruptcyStayTask {
        return Object.assign(new BankruptcyStayTask(), raw);
    }
}

export class BankAccountTask {
    public name!: string;
    public address1!: string;
    public routingNo!: string;
    public accountNo!: string;
}

export class ValuationTask {
    //public documentIds: number[]; //do i really need this reference since a document is stored with the categoryType, categorySubType and categoryId ?
}

export class PropertyTask{
    public id?:number;
    public propertyId!:number;
    public taskType!:string;  //see map down below
    public task!:Task;

    constructor(){
    }

    public static taskTypeMap: Record<string, new () => Task> = {
        'insurance':                InsuranceTask,
        'auditor_information':      AuditorInformationTask,
        'order_appointing_receiver': OrderAppointingReceiverTask,
        'bond_filed':               BondFiledTask,
        'oath_filed':               OathFiledTask,
        'receiver_reports':         ReceiverReportsTask,
        'order_terminating_receiver': OrderTerminatingReceiverTask,
        'bankruptcy_stay':          BankruptcyStayTask,
        'bank_account':             BankAccountTask,
        'valuation':                ValuationTask,
    };

    public static taskNameMap: Record<string, string> = {
        'insurance':                'Insurance',
        'auditor_information':      'Auditor Information',
        'order_appointing_receiver': 'Order Appointing Receiver',
        'bond_filed':               'Bond Filed',
        'oath_filed':               'Oath Filed',
        'receiver_reports':         'Receiver Reports',
        'order_terminating_receiver': 'Order Terminating Receiver',
        'bankruptcy_stay':          'Bankruptcy Stay',
        'bank_account':             'Bank Account',
        'valuation':                'Valuation',
    };

    public static taskSingularityMap: Record<string, boolean> = {
        'insurance':                false,
        'auditor_information':      true,
        'order_appointing_receiver': true,
        'bond_filed':               true,
        'oath_filed':               true,
        'receiver_reports':         true,
        'order_terminating_receiver': true,
        'bankruptcy_stay':          false,
        'bank_account':             false,
        'valuation':                true,
    };

    public static mapToDTO(param: PropertyTask): PropertyTaskDTO {
        ;
        let dto = new PropertyTaskDTO();
        try {
            dto.id = param.id;
            dto.propertyId = param.propertyId;
            dto.taskType = param.taskType;
            const data = (param.task as any)?.serialize
                ? (param.task as any).serialize()
                : param.task;
            dto.task = JSON.stringify(data, (key, value) => value ?? undefined);
        } catch (e) {
            console.log(e);
        }
        return dto;
    }

    public static mapFromDTO(param: PropertyTaskDTO): PropertyTask {
        ;
        let obj = new PropertyTask();
        try {
            obj.id = param.id;
            obj.propertyId = param.propertyId;
            obj.taskType = param.taskType;
            if (param.task) {
                const raw = JSON.parse(param.task);
                const TaskClass = PropertyTask.taskTypeMap[param.taskType];
                if (TaskClass) {
                    obj.task = (TaskClass as any).deserialize
                        ? (TaskClass as any).deserialize(raw)
                        : Object.assign(new TaskClass(), raw);
                }
            }
        } catch (e) {
            console.log(e);
        }
        return obj;
    }
}

